// extracted by mini-css-extract-plugin
module.exports = {"remindPasswordModal":"_1S4FNd"};